export default __webpack_public_path__ + "static/media/tl-regulation.3446d2e7.png";